import { useEffect, useState } from 'react';

export const parseBinding = (raw) => {
  if (!raw) return null;
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const readPageData = () => {
  const script = document.getElementById('umr-page-data');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent || 'null');
  } catch (error) {
    return null;
  }
};

const bindingKey = (binding) => {
  if (binding?.key) return binding.key;
  const suffix = (binding?.ids || []).join('-').slice(0, 48) || binding?.type || '';
  return binding?.type ? `${binding.type}-${suffix}` : '';
};

export const useBoundData = (binding) => {
  const pageData = readPageData();
  const key = binding?.id || bindingKey(binding);
  const stored = pageData?.bindings || {};
  const cached = (key && stored[key])
    || (binding?.key && stored[binding.key])
    || (binding?.id && Object.values(stored).find(item => item && (item.id === binding.id || item.key === binding.key)))
    || null;
  const initialItems = Array.isArray(cached?.items)
    ? cached.items
    : (Array.isArray(binding?.items) ? binding.items : undefined);
  const [items, setItems] = useState(() => (Array.isArray(initialItems) ? initialItems : []));
  const [loading, setLoading] = useState(() => !Array.isArray(initialItems));

  useEffect(() => {
    if (Array.isArray(initialItems)) {
      setItems(initialItems);
      setLoading(false);
      return undefined;
    }
    if (binding?.load === 'static') {
      setItems([]);
      setLoading(false);
      return undefined;
    }
    const params = new URLSearchParams();
    if (binding?.id) {
      params.set('binding', binding.id);
    } else {
      const ids = binding?.ids || cached?.ids || [];
      if (!ids.length || !binding?.type) {
        setItems([]);
        setLoading(false);
        return undefined;
      }
      params.set('type', binding.type);
      ids.forEach((id) => params.append('id', id));
    }
    let cancelled = false;
    fetch(`/rest/page/bound_data/?${params}`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((data) => {
        if (cancelled) return;
        setItems(Array.isArray(data?.results) ? data.results : []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [binding?.id, binding?.type, binding?.mode, binding?.load, binding?.key, JSON.stringify(binding?.ids || [])]);

  return { items, loading };
};
